import { Box, Tooltip, Typography } from '@mui/material';
import type { WorkflowTemplateIconKey } from '../model';
import { ValueBadge, createFocusRingStyles, designTokens } from '../../../design-system';
import { workflowTemplateIconVisual } from '../workflowTemplateIcons';

export function WorkflowRequestTemplateTitleIcon({
  name,
  version,
  iconKey,
  category,
  description,
}: {
  name: string;
  version?: number;
  iconKey: WorkflowTemplateIconKey;
  category?: string;
  description?: string;
}) {
  const visual = workflowTemplateIconVisual(iconKey);
  return <Tooltip
    describeChild
    title={<Box sx={{ maxWidth: 300 }}>
      <Typography component="div" variant="caption" sx={{ fontWeight: 800 }}>{name} 양식{version ? ` · v${version}` : ''}</Typography>
      {category ? <Typography component="div" variant="caption" sx={{ mt: 0.25, opacity: 0.82 }}>분류 · <ValueBadge size="compact" label={category} /></Typography> : null}
      {description ? <Typography component="div" variant="caption" sx={{ mt: 0.5 }}>{description}</Typography> : null}
    </Box>}
  >
    <Box
      component="span"
      role="img"
      tabIndex={0}
      aria-label={`워크플로우 양식 정보: ${name}`}
      data-testid={`workflow-request-template-icon-${iconKey.toLowerCase()}`}
      sx={{
        width: '100%',
        height: '100%',
        display: 'inline-grid',
        placeItems: 'center',
        borderRadius: designTokens.radius.surface,
        bgcolor: visual.surface,
        color: visual.color,
        '&:focus-visible': createFocusRingStyles(),
      }}
    >{visual.icon}</Box>
  </Tooltip>;
}
